// The single place the production origin lives in code (robots.txt in
// apps/web/public is the one other spot — a spec asserts they can't drift).
// Canonicals, og:url and the sitemap all derive from this, so pointing the
// site at a new domain is a one-line change.
export const SEO_BASE_URL = 'https://askvo.io';

export const SITE_NAME = 'Askvo';

// Defaults mirror index.html so prerendered pages that don't override them
// still match what a crawler sees in the raw document.
// Brand goes last: "AI customer support chatbot" is the head term buyers
// actually search, and a leading brand name spends the weighted front of the
// title on a name nobody looks for yet. 52 chars, so the SERP won't truncate.
export const DEFAULT_TITLE = 'AI Customer Support Chatbot for Your Website — Askvo';
export const DEFAULT_DESCRIPTION =
  "An AI customer support chatbot for your website, trained on your content. Answers 24/7, admits what it doesn't know, and hands off to a human. Live in 5 minutes.";

export function absoluteUrl(path: string): string {
  if (!path.startsWith('/')) {
    path = `/${path}`;
  }
  return `${SEO_BASE_URL}${path === '/' ? '/' : path}`;
}

// Shared social-share image every page falls back to unless it sets a more
// specific one (e.g. a future per-post blog image).
export const DEFAULT_OG_IMAGE = absoluteUrl('/og-image.png');
export const DEFAULT_OG_IMAGE_WIDTH = 1200;
export const DEFAULT_OG_IMAGE_HEIGHT = 630;

// Intentionally empty, and should stay that way: askvo.io is verified in
// Search Console by DNS TXT record (google-site-verification=bcMw0Vw2Bz...
// on the apex), which is a *domain* property — it covers every subdomain and
// both protocols, and survives redeploys. The meta tag is the weaker,
// per-origin alternative; emitting it too would add a tag to every page for
// no gain.
//
// Kept as a constant rather than deleted because the wiring in
// seo.service.ts is the escape hatch if the domain ever moves to a host
// where DNS isn't ours to edit: set this and the tag ships on every page.
export const SEARCH_CONSOLE_VERIFICATION = '';
